module.exports = __webpack_public_path__ + "static/media/root.a194993d.scss";


//////////////////
// WEBPACK FOOTER
// ./src/scss/root.scss
// module id = 18
// module chunks = 0